import { make } from 'vuex-pathify'

// API's
import Preguntas from '@/api/promotores/examenes/preguntas.api'

const state = {

    // Almacena la seleccion individual del elemento
    // Facilita el acceso desde otros componentes.
    seleccion: {},
}

const mutations = make.mutations(state)
const getters = make.getters(state)

const actions = {
    /**
     * Create a new pregunta.
     * @param {Object} context
     * @param {Object} payload 
     * @returns {Promise}
     */
    add(context, { examen, pregunta }) {
        return Preguntas.add(examen, pregunta)
    },

    /**
     * Update a pregunta.
     * @param {Object} context
     * @param {Object} payload 
     * @returns {Promise}
     */
    update(context, { examen, pregunta: { id, ...payload } }) {
        return Preguntas.update(examen, id, payload)
    },

    /**
     * Delete a pregunta.
     * @param {Object} context
     * @param {Object} payload 
     * @returns {Promise}
     */
    delete(context, { examen, pregunta }) {
        return Preguntas.delete(examen, pregunta)
    }
}

export default {
    namespaced: true,
    state,
    mutations,
    getters,
    actions,
}